// table.tsx

import { Table } from "../../../features/Table";
import { type N1Portfolio, porfolios_columns } from "./columns";
import { type FilterN1PortfoliosSchema, FilterN1Portfolios } from "./filter";

const client = "n1";
const table_name = "n1_portfolios";

export const N1PortfoliosTable = () => {
  return (
    <Table<N1Portfolio, FilterN1PortfoliosSchema>
      label="Portfolios"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      columnVisibilityInit={{}}
      filter={<FilterN1Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
